module.exports = __webpack_public_path__ + "static/media/logo.04b39f39.png";